<div class="flex-auto bg-card p-8">
    <h2 class="text-2xl font-semibold mb-6">Nuevo Usuario</h2>

    <form #usuario="ngForm" (ngSubmit)="submit(usuario)" class="grid grid-cols-1 md:grid-cols-2 gap-2 max-w-4xl" novalidate>
         <!-- Nombre -->
        <mat-form-field class="md:col-span-2 fuse-mat-dense"  >
            <mat-label>Nombre</mat-label>
            <input matInput name="firstName" [(ngModel)]="form.nombreCompleto" />
        </mat-form-field>

        <div class="flex md:col-span-2 gap-2">
            <!-- Rol -->
            <mat-form-field   class="w-full fuse-mat-dense">
                <mat-label>Rol</mat-label>
                <mat-select name="rol" required [(ngModel)]="form.rol" #rol="ngModel">
                    <mat-option *ngFor="let t of roles" [value]="t">{{ t.descripcion | titlecase }}</mat-option>
                </mat-select>
                <mat-error *ngIf="rol.invalid && (rol.touched)">Requerido</mat-error>
            </mat-form-field>

            <!-- Dependencia -->
            <mat-form-field   class="w-full fuse-mat-dense">
                <mat-label>Dependencia</mat-label>
                <mat-select name="dependencia" required [(ngModel)]="form.dependencia" #dependenciaCtrl="ngModel">
                    <mat-option *ngFor="let d of dependencias" [value]="d">{{ d.descripcion | titlecase }}</mat-option>
                </mat-select>
                <mat-error *ngIf="dependenciaCtrl.invalid && (dependenciaCtrl.touched)">Requerido</mat-error>
            </mat-form-field>
        </div>

        <!-- Email -->
        <mat-form-field class="md:col-span-2 fuse-mat-dense"  >
            <mat-label>Correo</mat-label>
            <input matInput type="email" placeholder="email@address.com" name="email" required email [(ngModel)]="form.email" #email="ngModel" />
            <mat-error *ngIf="email.invalid && (email.touched)">Correo inválido</mat-error>
        </mat-form-field>

        <!-- Password -->
        <mat-form-field class="md:col-span-2 fuse-mat-dense">
            <mat-label>{{isEdit? 'Modificar Contraseña': 'Contraseña'}}</mat-label>
            <input
                id="password"
                matInput
                type="password"
                placeholder="********"
                name="password"
                [required]="!isEdit"
                [(ngModel)]="form.password"
                #password="ngModel"
                #passwordField
            />
            <button
                mat-icon-button
                type="button"
                (click)="
                    passwordField.type === 'password'
                        ? (passwordField.type = 'text')
                        : (passwordField.type = 'password')
                "
                matSuffix
            >
                @if (passwordField.type === 'password') {
                    <mat-icon
                        class="icon-size-5"
                        [svgIcon]="'heroicons_solid:eye'"
                    ></mat-icon>
                }
                @if (passwordField.type === 'text') {
                    <mat-icon
                        class="icon-size-5"
                        [svgIcon]="'heroicons_solid:eye-slash'"
                    ></mat-icon>
                }
            </button>
            <mat-error *ngIf="password.errors?.['required'] && password.touched">Contraseña requerida</mat-error>
        </mat-form-field>

        <!-- Actions -->
        <div class="md:col-span-2 flex items-center gap-4 pt-4 justify-end">
            <button mat-stroked-button type="button" (click)="dialogRef.close()">Cancelar</button>
            <button mat-flat-button color="primary" type="submit" [disabled]="!usuario.valid">
                {{isEdit? 'Actualizar' :'Agregar Usuario' }}
            </button>
        </div>
    </form>
</div>
